import React, { createContext, useContext, ReactNode } from 'react';

interface JobContextType {
  jobCategoryMapping: { [key: string]: number };
  jobTypeMapping: { [key: string]: number };
}

const JobContext = createContext<JobContextType | undefined>(undefined);

export const JobProvider = ({ children }: { children: ReactNode }) => {
  const jobCategoryMapping: { [key: string]: number } = {
    'IT': 1,
    'Engineering': 2,
    'Finance': 3,
    'HR': 4,
  };

  const jobTypeMapping: { [key: string]: number } = {
      'Full Time': 1,
      'Part Time': 2,
      'Contract': 3,
      'Internship': 4,
  };

  return (
    <JobContext.Provider value={{ jobCategoryMapping, jobTypeMapping }}>
      {children}
    </JobContext.Provider>
  );
};

export const useJobContext = () => {
  const context = useContext(JobContext);
  if (!context) {
    throw new Error('useJobContext must be used within a JobProvider');
  }
  return context;
};
